// extracted by mini-css-extract-plugin
export default {"tile":"DashboardTile_tile__tm4uK","coming_soon":"DashboardTile_coming_soon__Tt0a7","image_container":"DashboardTile_image_container__nr4pJ"};